import { FolderIcon } from 'common/FolderIcon'
import { IReactNodeViewContext } from 'common/Prose/nodeViews/ReactNodeView/ReactNodeViewContext'
import { mentionsConversionOptions } from 'common/Prose/utils/mentionsConversionOptions'
import { MentionSubject, SmartLinkAttributes } from 'common/Prose/utils/smartLinks/types'
import { MentionsFormatBar } from 'components/MentionsFormatBar/MentionsFormatBar'
import { useFolder } from 'hooks/queries/folders/useFolder'
import { useEffect, useState } from 'react'
import { type EditableSmartLinkChildProps } from './EditableSmartLink'

export const FolderSmartLink = (props: EditableSmartLinkChildProps) => {
  const {
    sanitizedHTML,
    nodeViewContext,
    dataProps,
    handleLinkClick,
    showMentionFormatBar,
    setShowMentionFormatBar,
    parentRef,
  } = props
  const { node, getPos, view } = nodeViewContext as IReactNodeViewContext
  const attrs = node.attrs
  const { key, type, url, title } = attrs as SmartLinkAttributes

  const [mentionSubject, setMentionSubject] = useState<MentionSubject | null>({
    title: title,
    avatar: { emoji: <FolderIcon /> },
  })

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { data: folderData } = useFolder(key!, { staleTime: 10 * 1000 })

  useEffect(() => {
    if (type !== 'Folder' || !folderData) return
    const { title, header_emoji } = folderData.folder

    setMentionSubject({
      avatar: { emoji: header_emoji ?? <FolderIcon /> },
      title: title,
    })
  }, [type, folderData])

  const displayTitle = mentionSubject?.title || title

  return (
    <>
      {showMentionFormatBar && (
        <MentionsFormatBar
          view={view}
          close={() => setShowMentionFormatBar(false)}
          getPos={getPos}
          mentionSubject={mentionSubject}
          subtitle={''}
          smartLinkUuid={dataProps['data-uuid']}
          link={url}
          node={node}
          onLinkClick={handleLinkClick}
          conversionOptions={mentionsConversionOptions(node, getPos(), view, displayTitle)}
          parentRef={parentRef}
          forceFormatBarVisible={setShowMentionFormatBar}
          linkPosition={{ from: getPos(), to: getPos() + node.nodeSize }}
        />
      )}
      <a
        data-test-id="smart-link-editable"
        {...dataProps}
        href={url}
        onClick={handleLinkClick}
        tabIndex={-1}
        rel="noreferrer"
        dangerouslySetInnerHTML={sanitizedHTML}
      ></a>
    </>
  )
}
